import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PivcApiServices } from '../services/pivc-api.service';
import { LocalStorageService } from '../utility/local-storage.service';
import { utilityConfig } from '../utility/app-config';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {
  public byteString: any;
  public dbImageId: any;
  public currentImageId: any;
  public dataArray = [];
  constructor(public restApi: PivcApiServices, public router: Router) {}

  /*
   * Initial Hook
   */
  ngOnInit() {
    const dbImage = this.dataURItoBlob(utilityConfig.dbImage);
    const currentImage = this.dataURItoBlob(utilityConfig.currentImage);
    const fileArray = {
      dbImage: URL.createObjectURL(dbImage),
      currentImage: URL.createObjectURL(currentImage)
    };
    this.appendImage(fileArray);
    // const [face1, face2] = [this.dataArray[0], this.dataArray[1]];

    const formData = new FormData();
    formData.append('face_image_1', dbImage, 'abc.jpeg');
    formData.append('face_image_2', currentImage, 'bcd.jpeg');

    this.restApi
      .faceComapareApi(utilityConfig.faceCompareUri, formData)
      .subscribe(response => {
        console.log(response);
      });
  }

  /*
   * Convert Data URI to File
   */
  dataURItoBlob(dataURI) {
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      this.byteString = atob(dataURI.split(',')[1]);
    } else {
      this.byteString = unescape(dataURI.split(',')[1]);
    }
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];
    let ia = new Uint8Array(this.byteString.length);
    for (let i = 0; i < this.byteString.length; i++) {
      ia[i] = this.byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  /*
   * method to append the Images as Per their ID
   */
  appendImage(fileArray: object): void {
    for (let [i, [key, value]] of Object.entries(Object.entries(fileArray))) {
      document.getElementById(key).setAttribute('src', value);
      // const index = parseInt(i) + 1;
      // const blobUrlNamearray = value.split('/');
      // const ImageTempName = blobUrlNamearray[blobUrlNamearray.length - 1];
      // this.dataArray.push(`${ImageTempName}.jpeg`);
    }
  }
}
